// Copyright: IQGeo Limited 2010-2019
import myw from 'myWorld/base/core';
import 'myWorld/base/pluginButton';

myw.EditButton = myw.PluginButton.extend({
    id: 'details-editable',
    imgSrc: 'images/actions/edit.svg',
    inactiveImgSrc: 'images/actions/edit.svg',
    titleMsg: 'edit_details',
    /**
     * Creates a 'Edit' button for features
     * The button puts the current feature in 'edit' mode
     * @constructs
     * @extends {PluginButton}
     */
    initialize(...args) {
        myw.PluginButton.prototype.initialize.apply(this, args);
        this.app.system.userHasPermission('editFeatures').then(hasPerm => {
            if (!hasPerm) this.remove();
        });
    },
    render() {
        const feature = this.app.currentFeature;
        const active = feature && feature.isEditable() && !this.owner.editor && this.app.isFeatureEditable(feature.type, feature);
        this.setActive(active);
    },
    action() {
        this.owner.setMode('edit');
        this.app.recordFunctionalityAccess('core.details_tab.edit_feature');
    }
});

export default myw.EditButton;
